import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import axios from 'axios';
import translate from '../../../translate';
import UserProp from '../../../propTypes/userProp';
import Notifications from '../../../../services/notifications';
import withCSRF from '../../../withCSRF';
import { compose } from '../../../../services/utilityFunctions';
import CurrencyProp from '../../../../sections/profile/propTypes/currencyProp';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';
import MarketInfosContext from '../../../../contextProviders/MarketInfosContext';

function CurrencySelector({ t, _csrf, profile, currencies }) {
  const { loggedUser } = useContext(LoggedUserContext);
  const { setMarketInfos } = useContext(MarketInfosContext);
  const [currencyFilter, setCurrencyFilter] = useState('');
  const handleLangFilterChange = ({ currentTarget }) =>
    setCurrencyFilter(currentTarget.value);

  const handleCurrencySelection = currency => {
    axios
      .put(
        '/api/user/me/settings',
        { currency },
        {
          headers: {
            'Accept-Version': '1.0.0',
            'X-Gamification-API': 'Organization',
            'X-CSRF-Token': _csrf,
            _csrf,
          },
        },
      )
      .then(() => {
        setMarketInfos('localCurrency', currency);
        Notifications.showNotificationSuccess(
          t('success'),
          t('success_update'),
        );
        window.location.reload();
      })
      .catch(err => {
        Notifications.showErrorFromRequest(err, 'error_profileUpdate');
      });
  };

  const handleCurrencyLocalStorage = currency => {
    setMarketInfos('localCurrency', currency);
  };

  const filteredCurrencies = currencyFilter
    ? currencies.filter(l =>
        l.name.toUpperCase().includes(currencyFilter.toUpperCase()),
      )
    : currencies;

  const userCurrency = (
    profile && profile.currency ? profile.currency : 'eur'
  ).toUpperCase();
  const selectedCurrency =
    currencies && currencies.length > 0
      ? currencies.find(l => l.code === userCurrency)
      : {};

  return (
    <li
      /* eslint-disable-next-line max-len */
      className="m-nav__item m-topbar__languages m-dropdown m-dropdown--small m-dropdown--arrow m-dropdown--align-right m-dropdown--mobile-full-width"
      m-dropdown-toggle="click"
      aria-expanded="false"
      style={{ marginRight: '1rem' }}
    >
      <button
        type="button"
        disabled={profile.currencyIsBlocked}
        className="m-nav__link m-dropdown__toggle currency-header-selector hint-button"
      >
        <span className="m-nav__link-text">
          {`${userCurrency} - ${selectedCurrency.symbol_native}`}
          <i
            className="m-menu__hor-arrow la la-angle-down"
            style={{ marginLeft: '0.2rem', fontSize: '0.8rem' }}
          />
        </span>
      </button>
      {profile.currencyIsBlocked && (
        <div className="hint">{t('currency.hint.message')}</div>
      )}
      <div className="m-dropdown__wrapper" style={{ zIndex: '101' }}>
        <span
          className="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"
          style={{ left: 'auto', right: '5px' }}
        />
        <div className="m-dropdown__inner">
          <div className="m-dropdown__header m--align-center">
            <span className="m-dropdown__header-subtitle">
              {t('select_currency')}
            </span>
          </div>
          <div className="m-dropdown__body">
            <input
              type="text"
              placeholder={t('find_currency')}
              value={currencyFilter}
              onChange={handleLangFilterChange}
              className="form-control m-input"
              style={{ marginBottom: '1rem' }}
            />
            <div
              className="m-dropdown__content"
              style={{
                padding: 0,
                maxHeight: '600px',
                overflowY: 'auto',
              }}
            >
              <ul className="m-nav m-nav--skin-light">
                {filteredCurrencies.map(l => (
                  <li
                    key={l.code}
                    className={cx({
                      'm-nav__item': true,
                      'm-nav__item--active': l.code === selectedCurrency.code,
                    })}
                  >
                    <a
                      data-testid={`testID-${l.code}`}
                      href="#"
                      onClick={() =>
                        loggedUser
                          ? handleCurrencySelection(l.code)
                          : handleCurrencyLocalStorage(l.code)
                      }
                      className={cx({
                        'm-nav__link': true,
                        'm-nav__link--active': l.code === selectedCurrency.code,
                      })}
                    >
                      <span
                        className="m-nav__link-icon"
                        style={{
                          marginRight: '0.5rem',
                          fontSize: '1.2rem',
                          width: '45px',
                        }}
                      >
                        {l.symbol_native}
                      </span>
                      <span className="m-nav__link-title m-topbar__language-text m-nav__link-text">
                        {l.name}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
}

CurrencySelector.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  profile: PropTypes.shape(UserProp.propType).isRequired,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
};

export default compose(translate, withCSRF)(CurrencySelector);
